import { createContext, type ReactNode, useContext } from "react";

export interface EvoUserInfo {
	userId: string;
	email: string;
	firstName?: string;
	lastName?: string;
	customerName?: string;
}

export interface AuthContextValue {
	getAccessToken?: (forceRefresh?: boolean) => Promise<string | null>;
	instanceId?: string;
	evoUserInfo?: EvoUserInfo;
}

const AuthContext = createContext<AuthContextValue>({});

export function useAuth(): AuthContextValue {
	return useContext(AuthContext);
}

interface AuthProviderProps {
	getAccessToken?: (forceRefresh?: boolean) => Promise<string | null>;
	instanceId?: string;
	evoUserInfo?: EvoUserInfo;
	children: ReactNode;
}

export function AuthProvider({
	getAccessToken,
	instanceId,
	evoUserInfo,
	children,
}: AuthProviderProps): React.ReactElement {
	return (
		<AuthContext.Provider value={{ getAccessToken, instanceId, evoUserInfo }}>
			{children}
		</AuthContext.Provider>
	);
}
